import { createSortOption } from "@nosto/preact"
import { getCollectionHandle } from "./helpers"

export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("popular", "Most Popular", { field: "stats.views", order: "desc" }),
    createSortOption("score", "Featured", { field: "_score", order: "desc" }),
    createSortOption("price", "Price: Low-High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High-Low", { field: "price", order: "desc" }),
    createSortOption("date", "Date: New-Old", { field: "datePublished", order: "desc" }),
    createSortOption("-date", "Date: Old-New", { field: "datePublished", order: "asc" }),
    // createSortOption("name", "Name: A-Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Name: Z-A", { field: "name", order: "desc" }),
    // createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
    // createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

const nativeProductCard = document.querySelector('.product-card-grid__items nova-product-card');
export const collectionHandle = nativeProductCard?.collectionHandle || getCollectionHandle();
export const isGiftCollection = window.GIFT_COLLECTION;

export const sizeFilterOrder = [
    'XS', 'S', 'M', 'L', 'XL', 'OS'
]

export const colorHexes = {
    "Beige": "#CBA886",
    "Black": "#0C0B10",
    "Blue": "#ADD8E6",
    "Brown": "#845329",
    "Golden Brown": "#5c3c2b",
    "Green": "#008001",
    "Gray": "#999999",
    "Grey": "#999999",
    "Navy": "#000080",
    "Orange": "#FFA500",
    "Pink": "#FFC1CB",
    "Purple": "#A052F0",
    "Red" : "#DE242F",
    "White": "#FFFFFF",
    "Yellow": "#E0B87E",
    "Multi Color": "url(https://cdn.shopify.com/s/files/1/0052/8200/5085/files/Multi_Color.png?v=1756925962)",
    // "Multi": "linear-gradient(to bottom, #2857DA 0%, #2857DA 20%, #27DA46 20%, #27DA46 40%, #F5E319 40%, #F5E319 60%, #F38503 60%, #F38503 80%, #DE242F 80%, #DE242F 100%);",
}

// values are case-sensitive
const filterValueGroups = {
    // facet name in Nosto
    "Category" : { 
        // key = value to show
        "Storage and Care": [ 
            // actual filter values
            "gid://shopify/Metaobject/137967239307", // dev
            "gid://shopify/Metaobject/172377800797", // prod
        ],
        "Accessories": [
            "gid://shopify/Metaobject/137967272075",
            "gid://shopify/Metaobject/172377833565",
        ],
        "Tops": [
            "gid://shopify/Metaobject/137965305995",
            "gid://shopify/Metaobject/172377768029",
        ],
        "Lounge": [
            "gid://shopify/Metaobject/137965273227",
            "gid://shopify/Metaobject/172377735261",
        ],
        "Bottoms": [
            "gid://shopify/Metaobject/137965240459",
            "gid://shopify/Metaobject/172284575837",
        ],
        "Button Cardigans": [
            "gid://shopify/Metaobject/137965207691",
            "gid://shopify/Metaobject/172377702493",
        ],
        "Travel Wraps": [
            "gid://shopify/Metaobject/137965142155",
            "gid://shopify/Metaobject/172284477533",
        ],
        "Button Downs": [
            "gid://shopify/Metaobject/137965109387",
            "gid://shopify/Metaobject/172377636957",
        ],
        "Open Cardigans": [
            "gid://shopify/Metaobject/137965174923",
            "gid://shopify/Metaobject/172377669725",
        ],
        "Sweatshirts": [
            "gid://shopify/Metaobject/137965076619",
            "gid://shopify/Metaobject/172377604189",
        ],
        "Vests": [
            "gid://shopify/Metaobject/137965043851",
            "gid://shopify/Metaobject/172377571421",
        ],
        "Sleeveless": [
            "gid://shopify/Metaobject/137965011083",
            "gid://shopify/Metaobject/172377538653",
        ],
        "Dresses": [
            "gid://shopify/Metaobject/137964978315",
            "gid://shopify/Metaobject/172284543069",
        ],
        "Splitnecks": [
            "gid://shopify/Metaobject/137964912779",
            "gid://shopify/Metaobject/172377505885",
        ],
        "Turtlenecks": [
            "gid://shopify/Metaobject/137964880011",
            "gid://shopify/Metaobject/172377473117",
        ],
        "Scarves": [
            "gid://shopify/Metaobject/137363783819",
            "gid://shopify/Metaobject/172377440349",
        ],
        "Short Sleeve": [
            "gid://shopify/Metaobject/137363751051",
            "gid://shopify/Metaobject/172377342045",
        ],
        "V Necks": [
            "gid://shopify/Metaobject/137363718283",
            "gid://shopify/Metaobject/172377309277",
        ],
        "Cardigans": [
            "gid://shopify/Metaobject/137363685515",
            "gid://shopify/Metaobject/172284805213",
        ],
        "Long Sleeve": [
            "gid://shopify/Metaobject/137033187467",
            "gid://shopify/Metaobject/172377407581",
        ],
        "Sweaters": [
            "gid://shopify/Metaobject/137033154699",
            "gid://shopify/Metaobject/172377374813",
        ],
        "Cardigan": [
            "gid://shopify/Metaobject/137033121931",
            "gid://shopify/Metaobject/",
        ],
        "Crewneck": [
            "gid://shopify/Metaobject/136023736459",
            "gid://shopify/Metaobject/172377276509",
        ],
        "Essential Sweaters": [
            "gid://shopify/Metaobject/136018329739",
            "gid://shopify/Metaobject/",
        ],
        "Gloves": [
            "gid://shopify/Metaobject/",
            "gid://shopify/Metaobject/172377866333",
        ],
    },

    "Color": {
        "Beige": [
            "gid://shopify/Metaobject/143495561355", // dev
            "gid://shopify/Metaobject/172665864285", // main
        ],
        "Black": [
            "gid://shopify/Metaobject/143495594123",
            "gid://shopify/Metaobject/172665962589",
        ],
        "Blue": [
            "gid://shopify/Metaobject/143495659659",
            "gid://shopify/Metaobject/172665995357",
        ],
        "Brown": [
            "gid://shopify/Metaobject/143495692427",
            "gid://shopify/Metaobject/172666028125",
        ],
        "Green": [
            "gid://shopify/Metaobject/143495757963",
            "gid://shopify/Metaobject/172666060893",
        ],
        "Gray": [
            "gid://shopify/Metaobject/143495790731",
            "gid://shopify/Metaobject/172666126429",
        ], 
        "Navy": [
            "gid://shopify/Metaobject/143495823499",
            "gid://shopify/Metaobject/172666191965",
        ],
        "Orange": [
            "gid://shopify/Metaobject/143495889035",
            "gid://shopify/Metaobject/172666224733",
        ],
        "Pink": [
            "gid://shopify/Metaobject/143495921803",
            "gid://shopify/Metaobject/172666257501",
        ],
        "Purple": [
            "gid://shopify/Metaobject/143505195147",
            "gid://shopify/Metaobject/172753649757",
        ],
        "Red": [
            "gid://shopify/Metaobject/143495954571",
            "gid://shopify/Metaobject/172666290269",
        ], 
        "White": [
            "gid://shopify/Metaobject/143495987339",
            "gid://shopify/Metaobject/172666323037",
        ],
        "Yellow": [
            "gid://shopify/Metaobject/143496020107",
            "gid://shopify/Metaobject/172666388573",
        ],
        "Multi Color": [
            "gid://shopify/Metaobject/143496085643",
            "gid://shopify/Metaobject/172666159197",
        ]
    },
}

export const filterValueMapping = Object.fromEntries(
    Object.entries(filterValueGroups).map(([groupKey, groupValues]) => [
        groupKey,
        Object.fromEntries(
            Object.entries(groupValues).flatMap(([label, gids]) =>
                gids.map(gid => [gid, label])
            )
        )
    ])
);